import { AbilitySubjectType } from './ability.interface';
export var DefaultAbilityAction = /*#__PURE__*/function (DefaultAbilityAction) {
  DefaultAbilityAction["View"] = "View";
  DefaultAbilityAction["Manage"] = "Manage";
  DefaultAbilityAction["Create"] = "Create";
  DefaultAbilityAction["Read"] = "Read";
  DefaultAbilityAction["Update"] = "Update";
  DefaultAbilityAction["Delete"] = "Delete";
  return DefaultAbilityAction;
}(DefaultAbilityAction || {});
export const DefaultAbilityActionsMap = {
  [AbilitySubjectType.Feature]: [DefaultAbilityAction.View, DefaultAbilityAction.Manage],
  [AbilitySubjectType.Item]: [DefaultAbilityAction.Create, DefaultAbilityAction.Read, DefaultAbilityAction.Update, DefaultAbilityAction.Delete],
  [AbilitySubjectType.Programmatic]: []
};